<template>
  <div class="success">
    <section class="logo">
			<img src="@/assets/images/sp-logo.svg">
    </section>
    <section class="txt">
      <h2>このページを下に引いてください。</h2>
    </section>
  </div>
</template>
<script>
export default {
  methods: {
  },
  data () {
    return {
    }
  },
  components: {
  },
  mounted () {
  },
  methods: {
  },
}
</script>
<style scoped lang="scss">
  .logo {
    padding-left: 4vw;
    margin-top: 2vw;
    img {
      width: 24vw;
    }
  }

  .txt {
    padding-top: 36vw;
    text-align: center;
    h2 {
      font-size: 3.7vw;
      line-height: 5.6vw;
      text-align: center;
    }
    p {
      font-size: 2.2vw;
      line-height: 1;
      margin-top: 12vw;
    } 
    a {
      width: 35.7vw;
      height: 10.6vw;
      line-height: 10.6vw;
      border-radius: 5.3vw;
      text-align: center;
      color: white;
      background-color: $light-blue;
      display: inline-block;
      font-size: 4.2vw;
      margin-top: 48vw;
      margin-bottom: 50vw;
    }
  }
</style>